import $ from 'jquery'
import 'select2/dist/css/select2.css'
import 'select2'

// $('body').on('DOMNodeInserted', 'select', function () {
//     $(this).select2();
// });
$( document ).on('turbolinks:load', function() {
  $(document).on('select2:open', e => {
    const id = e.target.id;
    const target = document.querySelector(`[aria-controls=select2-${id}-results]`);
    target.focus();
  });

  $('.offline_account_name_search').select2({});
  $('.offline_user_search').select2({});
  $('.offline_department_search').select2({});
  $('.offline_designation_search').select2({});
  $('.offline_holiday_search').select2({});
  $('.offline_cat_name').select2({});
  $('.offline_cat_code').select2({});
    // $("#stock_order_id").select2()

  function ts_select2_accounts(elem){
    console.log("adas ",elem)
    elem.select2({
      ajax: {
        url: "/accounts/account_name_livesearch",
        method: "GET",
        dataType: 'json',
        delay: 250,
        data: function (params) {
          console.log(elem.attr("data-level"))
          console.log(elem.attr("data-option"))
          console.log(elem.attr("data-type"))

          return {
            account_name: params.term, // search term
            account_level: elem.attr("data-level"), // search term
            account_stage: elem.attr("data-astage"),
            account_type: elem.attr("data-atype")// search term
             // search term
          };
        },

        processResults: function (data, params) {
          return {
            results: data.data
          };
        },
        cache: true
      },

      placeholder: 'Select an Account',
      minimumInputLength: 1,
      templateResult: formatRepo,
      templateSelection: formatRepoSelection
    });
  }

  $(document).on('click', '.add_fields', function(){
    console.log('add fields clicked')
    var elems = $(".account_name_search")
    elems.each(function(){
      if(!$(this).hasClass('select2-hidden-accessible')){
        ts_select2_accounts($(this));
      }
    })
  });


  var elems = $(".account_name_search")
  elems.each(function(){
    console.log("aa lem atr", $(this).attr("data-level"))
    ts_select2_accounts($(this));
  })

  function formatRepo (repo) {
    if (repo.loading) {
      return repo.text;
    }

    var $container = $(
      "<div class='select2-account clearfix'>" +
        "<div class='select2-account_name'></div>" +
      "</div>"
    );

    $container.find(".select2-account_name").text(repo.account_name);
    return $container;
  }

  function formatRepoSelection (repo) {
    console.log("repo", repo.id)
    return repo.text;
  }

});
// Remove Select2 instances before caching the page to ensure a clean state on the next load.
$(document).on("turbolinks:before-cache", function () {
  $(".select2-hidden-accessible").select2("destroy");
});
